import GetApi from '../../../common/api/get'

export const FETCH_PICKUP_ROOM_GROUPS = "FETCH_PICKUP_ROOM_GROUPS"

export const setState = (namespace, payload) => ({
  type: `${namespace}: ${FETCH_PICKUP_ROOM_GROUPS}`,
  payload
})

export function getRoomGroups(namespace, query = {}) {
  return (dispatch, getState) => {
    return new GetApi().execute(routeUrlHelper.searchPath(query, { arrayFormat: 'bracket' }))
      .then(({ body }) => {
        return dispatch(setState(namespace, body))
      })
      .catch(error => {
        return dispatch(setState(namespace, { error }))
      })
  }
}
